export default "__VITE_ASSET__r$LwQPmF__"